<template>
    <div class="rpe-row">
        <div class="rpe-numbers">
            <span v-for="n in numbers" :key="n">{{ n }}</span>
        </div>
        <div ref="visual" class="rpe-visual" @pointerdown="onDown" @pointermove="onMove" @pointerup="onUp"
            @pointerleave="onUp">
            <div class="rpe-bg" />
            <div class="rpe-fill" :style="{ height: pct + '%' }" />
            <div class="rpe-handle" :style="{ bottom: pct + '%' }" />
        </div>
        <div v-if="label" class="rpe-label">{{ label }}</div>
    </div>
</template>

<script>
export default {
    name: "KimsaRpeSlider",
    props: {
        value: {
            type: [Number, String],
            default: 5,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 10,
        },
        label: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            dragging: false,
        }
    },
    computed: {
        model(vm = this) {
            return Number(vm.value)
        },
        pct(vm = this) {
            if (vm.max === vm.min) return 0
            return ((vm.model - vm.min) / (vm.max - vm.min)) * 100
        },
        numbers(vm = this) {
            const list = []
            for (let n = vm.max; n >= vm.min; n--) list.push(n)
            return list
        },
    },
    methods: {
        setFromEvent(e) {
            const vm = this
            const el = vm.$refs.visual
            if (!el) return
            const rect = el.getBoundingClientRect()
            const ratio = 1 - (e.clientY - rect.top) / rect.height
            const clamped = Math.min(1, Math.max(0, ratio))
            const val = Math.round(vm.min + clamped * (vm.max - vm.min))
            vm.$emit('change', val)
        },
        onDown(e) {
            this.dragging = true
            if (this.$refs.visual.setPointerCapture) this.$refs.visual.setPointerCapture(e.pointerId)
            this.setFromEvent(e)
        },
        onMove(e) {
            if (this.dragging) this.setFromEvent(e)
        },
        onUp() {
            this.dragging = false
        },
    },
}
</script>

<style scoped>
.rpe-row {
    display: flex;
    align-items: stretch;
    gap: 16px;
    height: 200px;
    margin-top: 12px;
}

.rpe-numbers {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 11px;
    color: var(--v-txtMuted-base);
    text-align: right;
    padding: 2px 0;
    width: 22px;
    flex-shrink: 0;
}

.rpe-visual {
    flex: 1;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    touch-action: none;
}

.rpe-bg {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top,
            rgba(204, 255, 51, 0.5) 0%,
            rgba(102, 204, 153, 0.5) 30%,
            rgba(102, 204, 204, 0.5) 60%,
            rgba(51, 153, 153, 0.5) 100%);
}

.rpe-fill {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, var(--v-primary-base), var(--v-secondary-base));
    transition: height 0.15s;
    border-radius: 0 0 8px 8px;
}

.rpe-handle {
    position: absolute;
    left: 0;
    right: 0;
    height: 2px;
    background: #fff;
    box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
    transition: bottom 0.15s;
}

.rpe-handle::before {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #fff;
    top: -6px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
}

.rpe-label {
    display: flex;
    align-items: center;
    width: 80px;
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 700;
    color: var(--v-txtSecondary-base);
}
</style>
